<template>
  <v-container id="regular-forms" fluid tag="section">
    <base-material-card
      color="#ac8a2e"
      icon="mdi-card-account-details"
      inline
      class="px-5 py-3"
      title="Pedidos de mercado"
    >
      <template v-if="$can('M_pedidos_edita')" v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewPedidoForm('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="buscar"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                Asignando pedido
              </v-card-title>
              <v-card-text>
                <validation-provider
                  v-slot="{ errors }"
                  name="scout"
                >
                  <v-select v-model="asignacion_pedido_mercado.user_id" color="gold" :error-messages="errors" label="Scout" item-value="user.id" item-text="user.name" :items="scouts" clearable>
                    <template v-slot:item="{ attrs, item, on }">
                      <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.user.name" />
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="assignItemConfirm"
                  >
                    Aceptar
                  </v-btn>
                  <v-spacer />
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="pedidos"
        :search.sync="buscar"
        :sort-by="['fecha']"
        :sort-desc="[true, false]"
        multi-sort
        @click:row="showItem"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="$can('M_pedidos_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToNewPedidoForm('edit', item.id)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip v-if="$can('M_pedidos_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip v-if="$can('M_pedidos_edita')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="assignItem(item)">
                mdi-account-group
              </v-icon>
            </template>
            <span>Asignar pedido</span>
          </v-tooltip>
          <v-tooltip v-if="$can('M_pedidos')" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" @click.stop="goToHistorial(item.id)">
                mdi-forum
              </v-icon>
            </template>
            <span>Historial</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        dialog: false,
        buscar: undefined,
        headers: [
          { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
          { text: 'Solicitante', sortable: true, value: 'solicitante' },
          { text: 'Club', value: 'club.descripcion' },
          { text: 'Liga', sortable: true, value: 'liga.descripcion' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        pedidos: [],
        scouts: [],
        editedIndex: -1,
        menu: false,
        notificar: false,
        showNotificar: false,
        dataForm: {
          id: '',
          fecha: '',
          solicitante: '',
          solicitante_contacto: '',
          club_id: '',
          detalle_solicitud: '',
          fecha_cierre: '',
          user_id: 0,
          club: {
            id: '',
            descripcion: '',
          },
          tieneAcciones: false,
        },
        asignacion_pedido_mercado: {
          id: '',
          fecha: '',
          pedido_mercado_id: '',
          user_id: '',
        },
      }
    },
    computed: {
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    created () {
      this.getPedidos()
      this.getScouts()
    },
    methods: {

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'También eliminará el seguimiento y las asignaciones.', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/pedido_delete/' + item.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Baja de pedido exitosa'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getPedidos()
      },

      assignItem (item) {
        this.goToAsignaciones(item.id)
      },

      close () {
        this.asignacion_pedido_mercado = Object.assign({}, null)
        this.dialog = false
      },

      assignItemConfirm: async function () {
        const method = 'post'
        await this.$http({
          method: method,
          url: '/api/asignacion_pedido_mercado_agregar',
          data: {
            ...this.asignacion_pedido_mercado,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Pedido asignado'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.close()
      },

      getPedidos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pedido_mercado_abiertos' }).then(response => { this.pedidos = response })
      },

      getScouts: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_scout' }).then(response => { this.scouts = response })
      },

      goToNewPedidoForm: function (modeVal, idPedido) {
        this.$router.push({ name: 'Alta pedido de mercado', params: { mode: modeVal, id: idPedido } })
      },

      goToHistorial: function (idPedido) {
        this.$router.push({ name: 'Seguimiento pedidos', params: { id: idPedido } })
      },

      goToAsignaciones: function (idPedido) {
        this.$router.push({ name: 'Asignaciones pedidos', params: { model: 'pedidos', id: idPedido } })
      },

      showItem (item) {
        this.goToHistorial(item.id)
      },
    },
  }
</script>
